<template>
    <div>
        <v-btn icon small v-if="hasDelete" :class="buttonClass">
            <v-icon :size="buttonSize" color="grey" @click="authActionHandle({eventType: 'delete'})">delete_forever</v-icon>
        </v-btn>
        <v-btn icon small :class="buttonClass">
            <v-icon :size="buttonSize" color="grey" @click="authActionHandle({eventType: 'favorites'})">{{ favoritesIcon }}</v-icon>
        </v-btn>
        <v-btn icon small :class="buttonClass">
            <v-icon :size="buttonSize" color="grey" @click="authActionHandle({eventType: 'cart'})">{{ cartIcon }}</v-icon>
        </v-btn>
        <v-btn icon small>
            <v-icon :size="buttonSize" class="pl-6" color="orange lighten-2" @click="authActionHandle({eventType: 'message'})">mail_outlined</v-icon>
        </v-btn>
        <v-btn icon small v-if="hasOften && isOften" class="ml-6">
            <v-icon :size="buttonSize" color="orange lighten-2" @click="authActionHandle({eventType: 'remove-often'})">remove_from_queue</v-icon>
        </v-btn>
        <v-btn icon small v-if="hasOften && !isOften" class="ml-6">
            <v-icon :size="buttonSize"  color="orange lighten-2" @click="authActionHandle({eventType: 'add-often'})">add_to_queue</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import ActionAccess from '../../../../app-front/mixins/ActionAccess';

    export default {
        name: "Actions",
        props:['id', 'isFavorite', 'isOften', 'isBasket', 'hasDelete', 'hasOften', 'size', 'wise'],
        mixins: [ActionAccess],
        data(){
            return {
                defaultButtonSize: 14,
            }
        },
        computed: {
            buttonClass() {
                const css = [];

                if(this.wise) {
                    css.push('mr-4');
                }

                return css;
            },
            buttonSize(){
                return this.size || this.defaultButtonSize;
            },
            favoritesIcon() {
                return this.isFavorite ? 'favorite' : 'favorite_border';
            },
            cartIcon() {
                return this.isBasket ? 'mdi-cart' : 'mdi-cart-outline';
            }
        },
        methods: {
            authSuccessActionHandle(data) {
                this.$emit(data.eventType)
            },
        }
    }
</script>

<style scoped>

</style>
